<template>
  <div class="change-password">
    <h2>Alterar Senha</h2>
    <form @submit.prevent="handleChangePassword">
      <div>
        <label for="currentPassword">Senha Atual:</label>
        <input type="password" v-model="currentPassword" required />
      </div>
      <div>
        <label for="newPassword">Nova Senha:</label>
        <input type="password" v-model="newPassword" required />
      </div>
      <div>
        <button type="submit">Alterar Senha</button>
      </div>
      <div v-if="errorMessage" class="error-message">
        {{ errorMessage }}
      </div>
      <div v-if="successMessage" class="success-message">
        {{ successMessage }}
      </div>
    </form>
  </div>
</template>

<script>
import userService from '../services/userService';

export default {
  data() {
    return {
      currentPassword: '',
      newPassword: '',
      errorMessage: '',
      successMessage: '', 
    };
  },
  methods: {
    async handleChangePassword() {
      const token = localStorage.getItem('token');

      try {
        const response = await userService.updatePassword(this.currentPassword, this.newPassword, token);
        this.currentPassword = '';
        this.newPassword = '';
        this.errorMessage = '';
        this.successMessage = 'Senha alterada com sucesso!'; 
      } catch (error) {
        this.errorMessage = error.response ? error.response.data.message : error.message;
        this.successMessage = ''; 
      }
    }
  }
};
</script>

<style scoped>
.change-password {
  max-width: 400px;
  margin: auto;
  padding: 2rem;
  background-color: #f9f9f9;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.change-password h2 {
  margin-bottom: 1rem;
  color: #003366;
}

.change-password form div {
  margin-bottom: 1rem;
}

.change-password label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: bold;
}

.change-password input {
  width: 100%;
  padding: 0.5rem;
  border-radius: 4px;
  border: 1px solid #ddd;
}

.change-password button {
  width: 100%;
  padding: 0.75rem;
  background-color: #28a745;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.change-password button:hover {
  background-color: #218838;
}

.error-message {
  color: #e74c3c;
  margin-top: 1rem;
  text-align: center;
}

.success-message {
  color: #28a745;
  margin-top: 1rem;
  text-align: center;
}
</style>
